import Routes from "./Routes";
import Permission from "./Permission";

// Роут страницы: имя ('nodes.show'), URL-маска ('/nodes/:id'), право (Permission|null).
export class Route {
    constructor(name, { mask, permission = null }) {
        this.name = name;
        this.mask = mask;
        this.permission = permission;
    }

    // Готовый URL по параметрам: route.url({id: 5}) → '/nodes/5'.
    // Не хватает параметра — null (ссылку рисовать нельзя).
    url(params = {}) {
        let url = this.mask;
        const matches = url.match(/:([a-zA-Z_]+)/g) ?? [];
        for (const match of matches) {
            const key = match.slice(1);
            const value = params[key];
            if (value === undefined || value === null || value === '') return null;
            url = url.replace(match, encodeURIComponent(value));
        }
        return url;
    }
}

// Порядок регистрации: 'create' ДО 'show' — иначе маска '/:id' перехватила бы '/create'.
// 'stream' — доп. слаг устройства ('/:id/stream'), тоже раньше '/:id'.
const SLUGS_ORDER = ['index', 'create', 'stream', 'show'];

// Логин выдаёт только index|show|create|edit|destroy — нестандартные слаги
// маппятся на ближайшее смысловое право.
const SLUG_PERMISSION_ACTIONS = { 'stream': 'show' };

// Реестр страниц панели. pages.add() из view/pages/pages.js строит Route + Permission
// на каждый слаг; права НЕ объявляются вручную — выводятся из префикса.
class Pages {
    all = [];

    // path — имя раздела в дереве роутов ('nodes'); components — {index, show, create};
    // permissionPrefix — префикс прав ('admin.nodes') либо null (страница без прав).
    add(path, components, permissionPrefix = null) {
        const routesOfPath = {};
        for (const slug of SLUGS_ORDER) {
            const mask = Routes.parseName(`${path}.${slug}`);
            if (mask === null) continue;
            const action = SLUG_PERMISSION_ACTIONS[slug] ?? slug;
            const permission = permissionPrefix
                ? new Permission(`${permissionPrefix}.${action}`, permissionPrefix)
                : null;
            routesOfPath[slug] = new Route(`${path}.${slug}`, { mask, permission });
        }
        for (const slug of SLUGS_ORDER) {
            if (!(slug in components) || !(slug in routesOfPath)) continue;
            this.all.push({
                path,
                slug,
                route: routesOfPath[slug],
                routes: routesOfPath,
                permission: routesOfPath[slug].permission,
                Component: components[slug],
            });
        }
    }
}

const pages = new Pages();

export default pages;
